// Regional Group API
import {
    RegionalGroupFilterRequestResponse,
} from 'app/Apps/AccountManagement/RegionalGroups/regionalGroups.types'
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type RegionalGroupRequests = {
    domainName: string,
    regionalGroupsFilterRequest: RequestConfigFunction<{
        params?: Record<string, any>
    }, RegionalGroupFilterRequestResponse>,
    GetRegionalGroupById: RequestConfigFunction<{ id: number }>,
    UpdateRegionalGroup: RequestConfigFunction<{ regionalGroupId: number }>,
    CreateRegionalGroup: RequestConfigFunction<undefined>,
    FilterCountRequest: () => {
        customUrl: string
    },
    getLinkedOpportunity: RequestConfigFunction<{ id: number }>,
}

const regionalGroupRequests: RegionalGroupRequests = {
    domainName: 'RegionalGroup',
    regionalGroupsFilterRequest: ({
        params,
    }) => {
        return {
            url: 'regionalgroup/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    GetRegionalGroupById: ({
        id,
    }) => {
        return {
            url: `regionalgroup/${id}`,
            method: 'GET',
        }
    },
    UpdateRegionalGroup: ({
        regionalGroupId,
    }) => {
        return {
            url: `regionalgroup/${regionalGroupId}`,
            method: 'PUT',
        }
    },
    CreateRegionalGroup: () => {
        return {
            url: 'regionalgroup',
            method: 'POST',
        }
    },
    FilterCountRequest: () => {
        return {
            customUrl: 'regionalgroup/filter-request/all',
        }
    },
    getLinkedOpportunity: ({
        id,
    }) => {
        return {
            url: `regionalgroup/${id}/linked-opportunity`,
            method: 'GET',
        }
    },
}

export default regionalGroupRequests
